import React, { PropsWithChildren } from 'react';
import { Link, useI18next } from 'gatsby-plugin-react-i18next';
import * as classes from './layout.module.scss';
import Logo from '../../images/logo.svg';
import { LanguageSwitch } from '../LanguageSwitch/LanguageSwitch';
import { PageWidth } from './PageWidth';

export const Header: React.FunctionComponent<PropsWithChildren> = props => {
    const { t } = useI18next('common');
    return (
        <header className={classes.headerContainer}>
            <PageWidth className={classes.headerInner}>
                <div className={classes.header}>
                    <div>
                        <Link to="/" className={classes.logoLink}>
                            <img src={Logo} alt={t('common:home')} lang="en" className={classes.logo}/>
                        </Link>
                    </div>
                    <LanguageSwitch/>
                </div>
                {props.children}
            </PageWidth>
        </header>
    );
};
